<template>
    <div class="report-config-container">
        
    </div>
</template>
<script>
import XLSX from 'xlsx';
import axios from 'axios';
import { ReportWizard } from '../../api';
import $ from 'jquery';

export default {
    data () {
        return {
            html: 'deault html content'
        }
    },
    async created () {
        
    },
    async beforeMount() {
        let file = await ReportWizard.fetchFilForPreview();
        let str = this.ab2str(file);
        let wb = XLSX.read(str, {type:'binary'});
        let sheetName = wb.SheetNames[0];
        let ws = wb.Sheets[sheetName];
        // let data =  XLSX.utils.sheet_to_html(ws);
        let data = XLSX.write(wb, {sheet:sheetName, type:'binary', bookType: 'html'})
        let parsedHTML = $.parseHTML(data);
        let table = parsedHTML[2];
        $(table).addClass('xls-table');
        $('.report-config-container').html(data);
    },
    mounted () {
        console.log($('.report-config-container').addClass('jhhm'))
        $('.xls-table').css('border', '1px solid black');
    },
    computed: {

    },
    methods: {
        ab2str: function (buf) {
            return String.fromCharCode.apply(null, new Uint8Array(buf));
        }
    }
}
</script>

<style scoped lang="scss">
    .report-config-container {
        height:50%;
        width: 100%;
        overflow: scroll;
    }
 
</style>





// WEBPACK FOOTER //
// src/components/report/ReportConfigWizard.vue